import { render, staticRenderFns } from "./SPRProfileEditor.vue?vue&type=template&id=555d1e5d&scoped=true"
import script from "./SPRProfileEditor.vue?vue&type=script&lang=ts"
export * from "./SPRProfileEditor.vue?vue&type=script&lang=ts"
import style0 from "./SPRProfileEditor.vue?vue&type=style&index=0&id=555d1e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d1e5d",
  null
  
)

export default component.exports